/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 25.07.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _get from 'lodash/get';

import Translate from '../../../../../components/Translate';
import DivLoader from '../../../../../components/DivLoader';

import {LogIn} from '../../../../../actions/_extentions/nar/actions-nar';
import {SetSettingsState} from '../../../../../actions/common/actions-common';

class NarLoginTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formDataUser: '',
      formDataPassword: ''
    }
  }

  componentDidMount() {
    this.__scrollUp();

    document.getElementById('user_login_settings') && document.getElementById('user_login_settings').focus();

    document.getElementById('dummy_submit') && document.getElementById('dummy_submit').addEventListener('focus', function (e) {

      document.getElementById('user_login_settings') && document.getElementById('user_login_settings').focus();
    }, true);
  }

  componentDidUpdate(prevProps) {

    if (prevProps.user.user !== this.props.user && this.props.user.user !== 'guest') {
      setTimeout(() => {

        this.__scrollBack();

        this.props.SetSettingsState({
          isShown: false,
          tabId: null
        });
      }, 350);
    }
  }

  componentWillReceiveProps(newProps) {

    if (newProps.isError) {
      document.getElementById('user_login_settings') && document.getElementById('user_login_settings').focus();
    }

  }

  __scrollUp = () => {
    var doc = document.documentElement || document.body;
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    if (top > 0) {
      document.body.scrollTop = document.documentElement.scrollTop = top - 15;
      setTimeout(this.__scrollUp, 25);
    }
  };

  __scrollBack = () => {
    if (!_get(this.props, 'settings.meta.fromPosition')) return;

    var doc = document.documentElement || document.body;
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    if (top < _get(this.props, 'settings.meta.fromPosition')) {

      document.body.scrollTop = document.documentElement.scrollTop = top + 100;
      setTimeout(this.__scrollBack, 5);
    }
  };

  _onUserNameChange = (event) => {

    this.setState({formDataUser: _get(event, 'target.value', '')});
  };

  _onPasswordChange = (event) => {

    this.setState({formDataPassword: _get(event, 'target.value', '')});
  };

  _onSubmit = (event) => {
    if (event.preventDefault) event.preventDefault();

    this.props.LogIn(this.state.formDataUser, this.state.formDataPassword);
  };

  _isLogin() {

    return this.props.user.user !== 'guest';
  }

  render() {
    if (this._isLogin()) {

      return (<div className="settings-col">
        <h3>
          <Translate content="settings.tabs.login.success" />
        </h3>
      </div>);
    }

    return (<div className="relative">
      <div className="settings-col">
        <DivLoader loading={this.props.inProgress} />
        <form id="authForm" className="js-form" role="form" onSubmit={this._onSubmit}>
          <label htmlFor="user_login_settings"> <Translate content="settings.tabs.login.email" /> </label>
          <input id="user_login_settings" name="username" type="text" className={'auth-field' + (this.props.isError ? ' error-field' : '')} tabIndex="1"
                 value={this.state.formDataUser} onChange={this._onUserNameChange} />
          <label htmlFor="user_password"> <Translate content="settings.tabs.login.password" /> </label>
          <input id="user_password" name="password" type="password" className={'auth-field' + (this.props.isError ? ' error-field' : '')} tabIndex="2"
                 value={this.state.formDataPassword} onChange={this._onPasswordChange} />
          <input id="dummy_submit" type="text" style={{height: 0, width: 0, opacity: 0, display: 'block', float: 'left'}} tabIndex="3" />
          <button type="submit" style={{height: 0, opacity: 0, visibility: 'hidden'}} tabIndex="3">Submit</button>
          <a className="btn-dark authorization" tabIndex="4" href="javascript:void(0)" onClick={this._onSubmit}> <Translate content="settings.tabs.login.sign_in" /> </a>
        </form>
        {this.props.isError && <div className="reg-error-message" style={{position: 'absolute', top: '22px', left: '264px'}}>
          <em> <Translate content="settings.tabs.login.error" /> </em>
        </div>}
      </div>
    </div>);
  }
}

NarLoginTab.propTypes = {
  settings: PropTypes.shape({
    type: PropTypes.string,
    isShown: PropTypes.bool,
    meta: PropTypes.shape({
      fromPosition: PropTypes.number
    })
  })
};

const mapStateToProps = ({auth: {user, auth:{inProgress, isError}}, common: {settings}}) => {

  return {settings, user, inProgress, isError};
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({LogIn, SetSettingsState}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(NarLoginTab);



// WEBPACK FOOTER //
// ./src/containers/Settings/Tabs/_extentions/nar/nar-login.js